export default function app(hydrateApp) {
    function startApp() {
        if (!('objectFit' in document.body.style)) {
            import(
                /* webpackChunkName: "object-fit" */
                'object-fit-images'
            ).then(({default: objecFit}) => objecFit());
        }
        hydrateApp();
    }

    const readyState = document.readyState;
    if (readyState === 'interactive' || readyState === 'complete') {
        startApp();
    } else {
        document.addEventListener('DOMContentLoaded', startApp);
    }
}
